import { useState } from 'react'
import axios from 'axios'
import { useNavigate } from 'react-router-dom'

import { API_BASE_URL } from '../config/api'

export const useAuth = () => {
  const navigate = useNavigate()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState("")

  const login = async (credentials) => {
    setIsLoading(true)
    setError("")

    try {
      await axios.post(`${API_BASE_URL}/api/login`, credentials)
      navigate("/home")
    } catch (err) {
      setError(err.response?.data?.message || "Login failed. Please try again.")
    } finally {
      setIsLoading(false)
    }
  }

  const clearError = () => setError("")

  return { login, isLoading, error, clearError }
}